"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Checkbox2 = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _Checkbox3 = _interopRequireDefault(require("./Checkbox.styles"));

var _CheckMarkIcon = _interopRequireDefault(require("./CheckMarkIcon"));

var _excluded = ["className", "error"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Checkbox = /*#__PURE__*/_react.default.forwardRef(function Checkbox(props, ref) {
  var _clsx, _clsx3;

  var className = props.className,
      error = props.error,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _Checkbox3.default)();
  return /*#__PURE__*/_react.default.createElement(_Checkbox2.default, Object.assign({}, otherProps, {
    className: (0, _classnames.default)(classes.root, className),
    checkedIcon: /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(classes.icon, classes.checkedIcon, (_clsx = {}, (0, _defineProperty2.default)(_clsx, classes.iconRed, error), (0, _defineProperty2.default)(_clsx, classes.checkedIconRed, error), _clsx))
    }, /*#__PURE__*/_react.default.createElement(_CheckMarkIcon.default, {
      className: classes.checkMark
    })),
    icon: /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)({}, classes.iconRed, error))
    }),
    indeterminateIcon: /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(classes.icon, classes.checkedIcon, (_clsx3 = {}, (0, _defineProperty2.default)(_clsx3, classes.iconRed, error), (0, _defineProperty2.default)(_clsx3, classes.checkedIconRed, error), _clsx3))
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.indeterminateIconLine
    })),
    ref: ref,
    inputProps: _objectSpread(_objectSpread({}, otherProps.inputProps), {}, {
      'data-error': error
    }),
    disableRipple: true
  }));
});

Checkbox.propTypes = {
  /**
   * Whether or not the checkbox element is checked.
   */
  checked: _propTypes.bool,

  /**
   * Applies additional CSS classes to the wrapper of the `Checkbox` component.
   */
  className: _propTypes.string,

  /**
   * Whether or not the checkbox element is available to selection.
   */
  disabled: _propTypes.bool,

  /**
   * Applies error state styling to the `Checkbox` component.
   */
  error: _propTypes.bool,

  /**
   *
   */
  id: _propTypes.string.isRequired,

  /**
   * Applies indeterminate state styling to the `Checkbox` component.
   */
  indeterminate: _propTypes.bool,

  /**
   * Whether or not the HTML input is required before a form submission can occur.
   */
  required: _propTypes.bool
};
Checkbox.defaultProps = {
  checked: undefined,
  className: undefined,
  disabled: undefined,
  error: undefined,
  indeterminate: undefined,
  required: undefined
};
var _default = Checkbox;
exports.default = _default;
